const generateReducer = (entityName) => {
  const upperEntityName = entityName.toUpperCase();
  return {
    [`STARTED_FETCHING_${upperEntityName}`]: (state, { payload }) => {
      const { order, orderBy, search, filters, tag_ids } = payload;
      const statePart = Object.assign({}, state[entityName], {
        order,
        orderBy,
        search,
        filters,
        tag_ids,
        fetching: true,
      });
      return Object.assign({}, state, { [entityName]: statePart });
    },
    [`FETCHED_${upperEntityName}`]: (state, { payload }) => {
      const { page, nextPage, total, data } = payload;
      const [itemsById, ids] = data.reduce(
        ([itemsById, ids], item) => {
          return [
            Object.assign({}, itemsById, { [item.id]: item }),
            ids.concat(item.id),
          ];
        },
        [{}, []]
      );
      const statePart = Object.assign({}, state[entityName], {
        page,
        nextPage,
        total,
        ids,
        fetching: false,
      });
      return Object.assign({}, state, {
        [`${entityName}ById`]: itemsById,
        [entityName]: statePart,
      });
    },
    [`FAILED_FETCHING_${upperEntityName}`]: (state, { payload }) => {
      const statePart = Object.assign({}, state[entityName], {
        fetching: false,
      });
      return Object.assign({}, state, { [entityName]: statePart });
    },
  };
};

export default generateReducer;
